 $(function () {
    var left_right_margin = -$('.floating-bar').height() / 2,
        top_bottom_margin = -$('.floating-bar').width() / 2;

    $('.floating-bar-right,.floating-bar-left').css({
        'margin-top': left_right_margin
    });

    $('.floating-bar-top,.floating-bar-bottom').css({
        'margin-left': top_bottom_margin
    });
});